import { useSelector } from 'react-redux';
import { useResolveRoute } from '@mews/routing';
import { LocalizedText } from '@mews/framework';
import { ApplicationState } from '@mews-commander/types';
import { Breadcrumbs } from '../../components/BreadcrumbList';
import { PayoutReportHeader } from './components/PayoutReportHeader';
import { getPayoutReportUrl } from './selectors';
import { getUrlFilters } from './utils';

export const useGetBreadcrumbs = ({ headerTextKey }: { headerTextKey: Mews.TextKey }): Breadcrumbs => {
    const params = getUrlFilters();

    const resolveRoute = useResolveRoute();
    const url = useSelector((state: ApplicationState) => getPayoutReportUrl(state, { resolveRoute, params }));

    return [
        {
            text: params.startUtc && params.endUtc ? <PayoutReportHeader /> : <LocalizedText textKey={headerTextKey} />,
            url,
        },
        { text: <LocalizedText textKey={headerTextKey} />, active: true },
    ];
};
